module.exports = __webpack_public_path__ + "media/images/new_culture/factor-efficacy-399bf9ce10ebe410f79f0285b7c191a9.png";